import { BackArrow } from "../Icons/Icons"
import React, { useEffect, useState } from "react"
import noAvatar from "../../assets/images/icons/no_avatar.jpg"
import { getSlashDateFormat } from "../../utils/date"
import { getEmailInfoReq } from "../../features/emails/emails"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { useDispatch, useSelector } from "react-redux"
import PdfViewModal from "./Compose/EmailViewPdfModal"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { EMAILS_SENT_RECIPIENT, MESSAGES_DELIVERY_STATUS } from "../../config/featureFlagKeys"
import DeliveryStatusBadge from "../DeliveryStatusBadge/DeliveryStatusBadge"

const Email = ({ userData, openEmail, setOpenEmail }) => {
  const { triggerLoading } = useMyContextLoading()
  const dispatch = useDispatch()
  const deliveryOn = useSelector(selectFeatureFlag(MESSAGES_DELIVERY_STATUS))
  const sentRecipientOn = useSelector(selectFeatureFlag(EMAILS_SENT_RECIPIENT))
  const [letterData, setLetterData] = useState('')

  const getEmail = async () => {
    triggerLoading(true)
    const response = await dispatch(getEmailInfoReq({ letterId: openEmail, userId: userData?._id }))
    setLetterData(response?.payload?.data)
    triggerLoading(false)
  }
  useEffect(() => {
    getEmail()
  }, [])

  const recipient = sentRecipientOn
    ? (letterData?.to || userData?.secondaryEmail || userData?.email)
    : deliveryOn ? (letterData?.to || userData?.email) : userData?.email
  const dateLine = <span className="text-text-secondary">{getSlashDateFormat(letterData?.createdAt)}</span>

  return (
    <div className="flex flex-col justify-between gap-6 mb-6">
      <div className="w-full px-6 py-5 flex items-center justify-between gap-8">
        <div className="flex items-center justify-start gap-2 cursor-pointer" onClick={() => setOpenEmail('')}>
          <div className="h-6 w-6 flex items-center justify-center">
            <BackArrow />
          </div>
          <h5 className="font-bold text-xl-20">Back to List</h5>
        </div>
        <div className="flex flex-row min-w-0">
          <img src={noAvatar} alt="" className="cursor-pointer w-[40px] shrink-0 rounded-full md:mr-4" />
          <div className="hidden md:flex flex-col text-md min-w-0">
            <span className="text-text-primary font-semibold truncate" title={recipient}>{recipient}</span>
            {deliveryOn ? (
              <div className="flex items-center gap-2">
                {dateLine}
                <DeliveryStatusBadge delivery={letterData?.delivery} channel="email" />
              </div>
            ) : dateLine}
          </div>
        </div>
      </div>
      <div className="px-6 flex-1 min-h-[150px] flex flex-col w-full gap-4">
        <h4 className="break-words">{letterData?.subject}</h4>
        <div className="htmlContent break-words [overflow-wrap:anywhere]" dangerouslySetInnerHTML={{ __html: letterData?.htmlContent }} />
      </div>
      {letterData?.attachments?.length > 0 && <div className="flex p-5 gap-2 border-t border-divider">
        {letterData?.attachments.map((attachment) => {
          return (
            <div
              className="w-[56px] h-[56px] rounded-lg overflow-hidden cursor-pointer select-none relative"
            >
              <PdfViewModal pdf={attachment?.content} />
            </div>
          )
        })}
      </div>}
    </div>
  )
}
export default Email